
// this file determines which slates to show.  Please read through the comments in the first example thoroughly

/************************************************************************************************************* */
/**********                   SAMPLE ONE OFF SLATES - ANY SPORT                                   ************ */
/************************************************************************************************************* */
const slates = [
    {                       // use this NFL divisional game as a sample
        "value": 170, 
        "order": 1,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings SAMPLE (4 Games)",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("9/23/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("8/20/2024 9:30 PM GMT"),
        "salaryFile": "DKSalariesSatSun.csv"
    },
    {
        "value": 10,  // must be unique with every slate!  keep incrementing by 1 for each new slates. This value is used in rankings template.
        "order": 10, // order in slate DDL (if there are multiple)
        "recurring": "", // should be "YES" or "".  Keep it "" unless you want this slate to re-occur daily/weekly/etc... see MLB daily slate below for more info
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings: Preseason (Featured) 8-11-23", // name displayed to user in DDL
        "sport": "NFL", 
        "site": "DK",
        "slateType": "Classic", // down the road when other types of (non-classic) slates are added, use this
        "displaySlateDate": new Date("7/9/2023 1:00 PM GMT"), // in GMT!  When should we start showing the slate?
        "hideSlateDate": new Date("8/11/2023 11:00 PM GMT"), // in GMT!  When should we hide the slate? (likely when DK/FD "lock" entries)
        "salaryFile": "DK_NFL_Preseason_8-11-23.csv" // should be unique in this file by sport.  hosted in Azure.
      },
    {
        "value": 162,
        "order": 162,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings: Week 5 (All games)",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("6/1/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("10/6/2023 12:15 AM GMT"),
        "salaryFile": "DK_NFL_16Games.csv"
    },
    {
        "value": 163, 
        "order": 163,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "NFL Draftkings Sun/Mon (14 Games)",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("9/23/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("10/1/2023 5:00 PM GMT"),
        "salaryFile": "DK_NFL_SunMon.csv"
    },
    {
        "value": 164, 
        "order": 164,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "NFL Draftkings Superflex *NEW*",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Super",
        "displaySlateDate": new Date("10/13/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("10/22/2023 5:00 PM GMT"),
        "salaryFile": "DK_NFL_MainSuper.csv"
    },
    {
        "value": 165, 
        "order": 1,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings: THANKSGIVING",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("9/23/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("11/23/2023 5:30 PM GMT"),
        "salaryFile": "DK_Thanks.csv"
    },
    {
        "value": 169, 
        "order": 1,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "DK: WILD CARD (6 Games)",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("10/13/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("1/13/2024 9:30 PM GMT"),
        "salaryFile": "DK_WildCard.csv"
    },
    {
        "value": 171, 
        "order": 2,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "FD: Divisional SAT ONLY (2 Games)",
        "sport": "NFL",
        "site": "FD",
        "slateType": "Classic",
        "displaySlateDate": new Date("10/13/2023 3:00 PM GMT"), 
        "hideSlateDate": new Date("1/20/2024 9:30 PM GMT"),
        "salaryFile": "FDSalariesSat.csv"
    },
    {
        "value": 174, 
        "order": 3,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "DK: Conf Champ (2 Games)",
        "sport": "NFL",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("1/16/2024 3:00 PM GMT"), 
        "hideSlateDate": new Date("1/28/2024 8:00 PM GMT"),
        "salaryFile": "DKSalariesSun.csv"
    },
    {
        "value": 175, 
        "order": 4,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "FD: Conf Champ (2 Games)",
        "sport": "NFL",
        "site": "FD",
        "slateType": "Classic",
        "displaySlateDate": new Date("1/16/2024 3:00 PM GMT"), 
        "hideSlateDate": new Date("1/28/2024 8:00 PM GMT"),
        "salaryFile": "FDSalariesSun.csv"
    },
/************************************************************************************************************* */
/** NFL SUNDAY MAIN DK & FD FEATURED SLATES (1 RECORD FOR EACH WEEK) -- CLOCKS CHANGE Sun Nov 5, 2023   ****** */
/************************************************************************************************************* */
{
    "value": 29, 
    "order": 29, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 3 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("9/18/2023 12:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("9/24/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
  },
  {
    "value": 30,
    "order": 30, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 3 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("9/18/2023 12:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("9/24/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 31, 
    "order": 31, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 4 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("9/25/2023 2:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("10/1/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 32,
    "order": 32, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 4 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("9/25/2023 2:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("10/1/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 33, 
    "order": 33, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 5 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/2/2023 2:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("10/8/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 34,
    "order": 34, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 5 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/2/2023 2:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("10/8/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 35, 
    "order": 35, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 6 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/9/2023 2:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("10/15/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 36,
    "order": 36, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 6 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/9/2023 2:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("10/15/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 37, 
    "order": 37, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 7 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/16/2023 2:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("10/22/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 38,
    "order": 38, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 7 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/16/2023 2:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("10/22/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 39, 
    "order": 39, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 8 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/23/2023 2:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("10/29/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 40,
    "order": 40, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 8 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/23/2023 2:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("10/29/2023 5:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 41, 
    "order": 41, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 9 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/30/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("11/5/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 42,
    "order": 42, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 9 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("10/30/2023 3:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("11/5/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 43, 
    "order": 43, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 10 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/6/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("11/12/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 44,
    "order": 44, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 10 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/6/2023 3:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("11/12/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 45, 
    "order": 45, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 11 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/13/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("11/19/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 46,
    "order": 46, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 11 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/13/2023 3:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("11/19/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 47, 
    "order": 47, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 12 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/20/2023 12:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("11/26/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 48,
    "order": 48, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 12 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/20/2023 12:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("11/26/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 49, 
    "order": 49, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 13 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/27/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/3/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 50,
    "order": 50, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 13 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("11/27/2023 3:00 PM GMT"), // in GMT! 
    "hideSlateDate": new Date("12/3/2023 9:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 51, 
    "order": 51, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 14 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/4/2023 12:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/10/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 52,
    "order": 52, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 14 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/4/2023 12:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/10/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 352,
    "order": 352, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 14 (Early)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/4/2023 12:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/10/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Early.csv" 
    },
    {
    "value": 53, 
    "order": 53, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 15 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/11/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/17/2023 7:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 54,
    "order": 54, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 15 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/11/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/17/2023 7:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 55, 
    "order": 55, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 16 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/18/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/24/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 56,
    "order": 56, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 16 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/18/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/24/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 57, 
    "order": 57, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 17 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/25/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/31/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 58,
    "order": 58, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 17 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("12/25/2023 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("12/31/2023 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
    {
    "value": 59, 
    "order": 59, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Draftkings: Week 18 (Featured)",
    "sport": "NFL", 
    "site": "DK",
    "slateType": "Classic",
    "displaySlateDate": new Date("1/1/2024 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("1/7/2024 6:00 PM GMT"), // in GMT!
    "salaryFile": "DK_Main.csv"  
    },
    {
    "value": 60,
    "order": 60, 
    "recurring": "",
    "recurringDaysOfWeek" : "[]",
    "recurringHoursStart" : "",
    "recurringHoursHide" : "",
    "recurringMinutesHide" : "",
    "label": "Fanduel: Week 18 (Featured)",
    "sport": "NFL", 
    "site": "FD",
    "slateType": "Classic",
    "displaySlateDate": new Date("1/1/2024 3:00 PM GMT"), // in GMT!
    "hideSlateDate": new Date("1/7/2024 6:00 PM GMT"), // in GMT!
    "salaryFile": "FD_Main.csv" 
    },
/************************************************************************************************************* */
/**********                                           PGA                                         ************ */
/************************************************************************************************************* */
    {
        "value": 176,
        "order": 176,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings: Waste Management",
        "sport": "PGA",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("8/15/2023 11:55 AM GMT"), 
        "hideSlateDate": new Date("2/8/2024 11:55 PM GMT"),
        "salaryFile": "PGA-WasteManagement.csv"
    },
    {
        "value": 180,
        "order": 180,
        "recurring": "",
        "recurringDaysOfWeek" : "[]",
        "recurringHoursStart" : "",
        "recurringHoursHide" : "",
        "recurringMinutesHide" : "",
        "label": "Draftkings: Arnold Palmer",
        "sport": "PGA",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("8/15/2023 11:55 AM GMT"), 
        "hideSlateDate": new Date("3/7/2024 10:02 AM GMT"),
        "salaryFile": "PGA-ArnoldPalmer-Mar2024.csv"
    },
/************************************************************************************************************* */
/**********                       MLB - DK RECURRING DAILY/WEEKLY SLATES                          ************ */
/************************************************************************************************************* */
    {
        // CRUCIAL:  Recurring logic is wired up for MLB only (see HomeMLBFull.js -- which mimics Home.js)
        "value": 17,  // daily MLB slate. 6 days a week (M-Sat) there is a 6:05 PM CT slate, so this handles that recurring concept
        "order": 17,
        "recurring": "Yes", // 'Yes' triggers this slate to show up in the days of the week right below
        "recurringDaysOfWeek" : "[Monday, Tuesday, Wednesday, Thursday, Friday, Saturday]", // CRUCIAL: Only first letter should be capitalized
        "recurringHoursStart" : "17", // if 'Daily" this is GMT hours start/hide times. 17->23 will display the slate noon-6PM CT
        "recurringHoursHide" : "23", // CRUCIAL: Must be within same calendar day for recurring. 
                                          // Luckily, for MLB regular season Chicago is always 5 hours off
                                          // Basically, do *NOT* do recurring slates that cross over to the next GMT day of the week. 
                                          //    Instead, just do one-offs w/ a clear GMT start/end (displaySlateDate & hideSlateDate)
        "recurringMinutesHide" : "05", // 2 digits please!  if you want to hide it 5 minutes after the hour (e.g. 6:05 PM CT MLB start), put a "05" in here
        "label": "Draftkings: Daily Evening Slate (Featured)",
        "sport": "MLB",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("9/5/2023 11:05 AM GMT"),  // this date trumps all. if you don't want MLB to start until April 1, put it here
        "hideSlateDate": new Date("10/1/2023 11:00 PM GMT"), // this date trumps all.  if MLB reg season ends Oct 1, put that date here and nothing above matters
        "salaryFile": "DK_MLB_Main_Daily.csv"
    }
    ,
    {
        "value": 23,  // weekly Sunday only MLB slate
        "order": 23,
        "recurring": "Yes",
        "recurringDaysOfWeek" : "[Sunday]", // CRUCIAL: Only first letter should be capitalized. Just 'Sunday' makes this slate technically weekly
        "recurringHoursStart" : "14",
        "recurringHoursHide" : "17",
        "recurringMinutesHide" : "35", // 2 digits please!  if you want to hide it 35 minutes after the hour (e.g. 12:35 PM CT MLB start), put a "35" in here
        "label": "Draftkings: Sunday Afternoon Slate (Featured)",
        "sport": "MLB",
        "site": "DK",
        "slateType": "Classic",
        "displaySlateDate": new Date("8/28/2023 11:05 AM GMT"), // this date trumps all. if you don't want MLB to start until April 1, put it here
        "hideSlateDate": new Date("10/1/2023 11:00 PM GMT"), // this date trumps all.  if MLB reg season ends Oct 1, put that date here and nothing above matters
        "salaryFile": "DK_MLB_Main_Weekly.csv" // unique.
    }
  ];
  export default slates;